<div class="row search-bar-container">
  <div class="col-md-5 col-sm-12  col-xl-5 location-selector-container">
    <div class="item">
      <fa-icon [icon]="icons.search"></fa-icon>
    </div>
    <div class="item w-90">
      <!-- <app-location-selector [value]="searchValue" className="input-locator" placeholder="Search by Hotel, City or Region"
        [showErrorMsg]="false" [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
        (inputValue)="locationInputChange($event)" (values)="locationChange($event)"   >
      </app-location-selector> -->
      <div class="airline-dropdown-wrapper">
         
          <div  class="airline-select" >
            <div class="search-box">
              <!-- <fa-icon [icon]="icons.search" class="search-icon"></fa-icon> -->
              <input type="text"   
              [(ngModel)]="airlineSearch" 
              (click)="showList()"
              [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onSearchChange($event)" placeholder="Search by Hotel, City or Region" autocomplete="off">
<fa-icon (click)="clear()" [icon]="icons.close" class="search-icon" *ngIf="selectedLocation?.name?.length"></fa-icon>
                <div *ngIf="locationLoading" class="spinner-border text-primary spinner-border-sm" role="status">
  <span class="visually-hidden">Loading...</span>
</div>            </div>
            <div class="airline-dropdown" *ngIf="showLocationDropdown">
              <ul class="airline-list">
                <ng-container *ngIf="filteredLocations?.regions?.length > 0">
                  <li class="label-holder">Region</li>
                  <li class="d-flex gap-2" *ngFor="let a of filteredLocations?.regions" (click)="selectLocation(a)"
                  [class.selected]="selectedLocation?.region_id === a.region_id">
                  <fa-icon [icon]="icons.location" class="me-2"></fa-icon>
                  <span class="airline-name">{{ a.name + ', ' + a.country_name }}</span>
                                </li>
                </ng-container>
                <ng-container *ngIf="filteredLocations?.autoCompletedHotelData?.length > 0">
                  <li class="label-holder">Hotel</li>
                    <li class="d-flex gap-2" *ngFor="let a of filteredLocations?.autoCompletedHotelData" (click)="selectLocation(a)"
                      [class.selected]="selectedLocation?.hid === a.hid">
                      <fa-icon [icon]="icons.hotel" class="me-2"></fa-icon>
                      <span class="airline-name">{{ a.name }}</span>
                    </li>
                </ng-container>
                <li *ngIf="filteredLocations?.length === 0" class="no-results">No airlines found</li>
                <ng-container>
                                    <li class="label-holder">Others</li>

                  <li class="d-flex gap-2" *ngFor="let prediction of predictions"
                      (click)="selectPrediction(prediction)"
                      [class.selected]="selectedLocation?.placeId === prediction?.place_id">
                  
                    <fa-icon [icon]="icons.location" class="me-2"></fa-icon>
                    <span  class="airline-name">{{ prediction.description }}</span>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>
    </div>
  </div>
  <div class="col-md-7 col-sm-12 col-xl-7 d-flex align-items-center actions">
    <div class="col-md-5 col-sm-6 range-section px-3">
      <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.calendar"></fa-icon>
      <input class="date-picker-input" type="text" placeholder="Check-in & Out" [minDate]="minDate"
        [bsConfig]="{ isAnimated: true, showWeekNumbers: false, rangeInputFormat: 'DD-MM-YYYY', dateInputFormat: 'ddd, MMMM Do', preventChangeToNextMonth: true }"
        [(ngModel)]="dateRange" (ngModelChange)="onDateRangeChange($event)" #dp="bsDaterangepicker" bsDaterangepicker>
      <fa-icon class="icon-btn" (click)="dp.toggle()" [icon]="icons.caretDown"></fa-icon>
    </div>

    <form class="col-md-4 col-sm-6 guest-section" [formGroup]="form">
      <div data-bs-toggle="dropdown">
        <fa-icon [icon]="icons.users"></fa-icon>
        <input [formControlName]="'occupants'" class="guest-input" type="text" placeholder="Guests">
      </div>
      <ul class="dropdown-menu guest-dropdown" (click)="$event.stopPropagation()">

         <div formArrayName="bookingDataVm" class="guest-scroll-area">
          <ng-container *ngFor="let booking of bookingDataArr.controls; let i = index; let last = last"  >
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="mb-0 mt-3">Room {{i + 1}} </p>
              <a *ngIf="i !== 0"  class="title text-danger" type="button" (click)="removeRoom(i)">Remove Room </a>
            </div>
            <div class="row form-group">
<div class="col-md-12">
                      <label class="form-label mt-0">Adults</label>
                      <app-input  [className]="'p-0'"  [formGrp]="asFormGroup(booking)"  formCtrlName="adults" [value]="asFormGroup(booking).get('adults')?.value"   number></app-input>

                  </div>
                  <!-- <div class="col-md-6 col-6">
                      <label class="form-label mt-0">Pets   </label>
                      <app-input [className]="'p-0'" [formGrp]="asFormGroup(booking)"  formCtrlName="pets" [value]="asFormGroup(booking).get('pets')?.value"   number></app-input>

                  </div> -->
            </div>
            <div >
                 <div class="d-flex align-items-center justify-content-between">
                  <label class="form-label mt-0">Children</label>
                  <a *ngIf="selectedChildAgesIndex[i]?.ages?.length > 0" (click)="addChildAge()"  class="title" type="button" >Add  </a>
                </div>
                 <select class="form-select"
                 #childSelect
                 (change)="setChildAge($event.target, i)"
                 >
                  <option value="" disabled selected>Age range</option>
                  <option [value]="age" *ngFor="let age of childAge">{{age + 'years'}}</option>

                </select>


            </div>
            <div class="d-flex gap-2 w-100 flex-wrap my-2 ">
              <p class="age-badge mb-0" *ngFor="let age of asFormGroup(booking).get('children')?.value; let k = index">{{age+'years'}} <span (click)="removeAge(i, k)">x</span></p>
            </div>
            <div *ngIf="!last" class="room-divider"></div>
          </ng-container>
          <div class="d-flex align-items-center justify-content-between w-100 my-3">
                      <a  class="title" type="button" (click)="addRoom()">Add a room + </a>

              <app-button [className]="'w-100'"
        [disabled]="!isLocationSelected() || !dateRange "
        (onclick)="search()" warning>Done</app-button>
          </div>

        </div>


      </ul>
    </form>



    <div class="col-md-3 col-sm-12 search-button">
      <app-button [className]="'w-100'"
        [disabled]="!isLocationSelected() || !dateRange || (form.controls['rooms'].value <1)  || (form.controls['adults'].value <1)"
        (onclick)="search()" warning>Search</app-button>
    </div>

  </div>
</div>

